// **Der Kopf der Seite** (`pf-head`: Zurück-Link, Titel, Aktionen, Hinweis).
// Er steht im Rahmen (Shell), gefüllt wird er von der Ansicht: `<PageHead>`
// zeichnet per Portal hinein. So hängen die Knöpfe im Kopf an den Handlern
// der Ansicht, ohne dass der Rahmen von ihnen weiß.

import { createContext, useContext, useEffect, type ReactNode } from "react";
import { createPortal } from "react-dom";
import { Link } from "../router/router";

const HeadContext = createContext<HTMLElement | null>(null);

export function HeadProvider({ element, children }: { element: HTMLElement | null; children: ReactNode }) {
  return <HeadContext.Provider value={element}>{children}</HeadContext.Provider>;
}

/** `document.title` hat genau einen Schreiber: diesen. */
export function pageTitle(title: string): string {
  return `${title} · SoluCoder-Plattform`;
}

export function PageHead({ title, badge, hint, actions, back }: {
  /** Reiner Text — er steht auch im Tab (`document.title`). */
  title: string;
  /** Hinter dem Titel, nicht im Tab (Zustand eines Mandanten). */
  badge?: ReactNode;
  hint?: ReactNode;
  actions?: ReactNode;
  back?: readonly [href: string, label: string];
}) {
  const element = useContext(HeadContext);
  useEffect(() => { document.title = pageTitle(title); }, [title]);
  if (!element) return null;
  return createPortal(
    <>
      {back && <Link className="pf-back" to={back[0]}>← {back[1]}</Link>}
      <div className="pf-head__top">
        <h1 className="pf-head__title">{title}{badge ? <> {badge}</> : null}</h1>
        {actions ? <div className="pf-head__actions">{actions}</div> : null}
      </div>
      {hint ? <p className="pf-head__hint">{hint}</p> : null}
    </>,
    element,
  );
}
